var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch_language"},[_c('i-select',{class:{ 'select-size select-style': _vm.defaultFormStyle },on:{"input":function($event){return _vm.$emit('on-change')}},model:{value:(_vm.language),callback:function ($$v) {_vm.language=$$v},expression:"language"}},_vm._l((_vm.languageList),function(ref,index){
var label = ref.label;
var value = ref.value;
return _c('i-option',{key:index,attrs:{"value":value}},[_vm._v(" "+_vm._s(label)+" ")])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }